<button (click)="toggleFavorite()"
        [disabled]="awaitingResponse"
        [ngClass]="{active: product.favorite}"
        class="product-favorite-button">
	<span class="productitem-favorite-button__icon">
		<svg class="icon-heart" width="20" height="17">
			<use xlink:href="/images/icons/svg-sprite.svg#heart"></use>
		</svg>
	</span>
</button>
